import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../api";

export function ReceivePage() {
  const { token = "" } = useParams();
  const [phase, setPhase] = useState<"loading" | "email" | "files" | "dead">("loading");
  const [subject, setSubject] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [email, setEmail] = useState("");
  const [ticket, setTicket] = useState("");
  const [files, setFiles] = useState<{ fileId: string; fileName: string; sizeBytes: number }[]>([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .publicStatus(token)
      .then((r) => {
        setSubject(r.subject);
        setExpiresAt(r.expiresAt);
        setPhase("email");
      })
      .catch(() => {
        setError("この共有は利用できません");
        setPhase("dead");
      });
  }, [token]);

  const verify = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const r = await api.publicVerify(token, email);
      setSubject(r.subject);
      setExpiresAt(r.expiresAt);
      setFiles(r.files);
      setTicket(r.accessTicket);
      setPhase("files");
    } catch {
      setError("認証に失敗しました");
    }
  };

  const download = async (fileId: string) => {
    setError("");
    try {
      const r = await api.publicDownload(token, ticket, fileId);
      window.location.href = r.url;
    } catch {
      setError("ダウンロードに失敗しました");
    }
  };

  return (
    <div className="shell receive-shell">
      <div className="panel receive-panel">
        <header className="receive-brand">
          <img
            className="receive-logo"
            src="/TR-COM.png"
            alt="TR-COM"
            width={72}
            height={72}
          />
          <div>
            <p className="receive-brand-name">TR-COM</p>
            <h1>ファイル受け取り</h1>
          </div>
        </header>
        {phase === "loading" && <p className="muted">確認中...</p>}
        {phase === "dead" && <p className="error">{error}</p>}
        {phase === "email" && (
          <form className="stack" onSubmit={verify}>
            <p>
              <strong>{subject}</strong>
            </p>
            <p className="muted">有効期限: {expiresAt ? new Date(expiresAt).toLocaleString() : "-"}</p>
            <label>
              メールアドレス
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </label>
            {error && <p className="error">{error}</p>}
            <button className="btn" type="submit">
              確認
            </button>
          </form>
        )}
        {phase === "files" && (
          <div className="stack">
            <p>
              <strong>{subject}</strong>
            </p>
            <p className="muted">有効期限: {new Date(expiresAt).toLocaleString()}</p>
            {error && <p className="error">{error}</p>}
            <ul>
              {files.map((f) => (
                <li key={f.fileId} style={{ marginBottom: "0.75rem" }}>
                  {f.fileName}（{(f.sizeBytes / 1024 / 1024).toFixed(2)} MB）{" "}
                  <button className="btn" type="button" onClick={() => download(f.fileId)}>
                    ダウンロード
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
